import { createReducer, on } from '@ngrx/store'
import { ParamsConfigAction } from './params-config.action'
import { ParamsConfigModel } from '@appService/stores/params-config/params-config.model'
import { STORE_KEY_DONE } from '@appService/stores/store.constants'

export const initialState = {}

export const paramsConfigReducer = createReducer(
  initialState,
  on(ParamsConfigAction.ReplaceParamsConfig, (state: ParamsConfigModel, { payload } ) => {
    const data: any = {}
    Object.keys(payload).forEach(
      k => {
        if(!payload[`${k}_${STORE_KEY_DONE}`] && !state[`${k}_${STORE_KEY_DONE}`]) {
          data[`${k}_${STORE_KEY_DONE}`] = true
        }
      }
    )
    return {
      ...state,
      ...payload,
      ...data
    }
  })
)
